var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h4", { staticClass: "method-title" }, [_vm._v("Atualizar CAP")]),
      !_vm.resultsView
        ? _c("div", [
            _c(
              "div",
              { staticClass: "input-fields" },
              [
                _c(
                  "b-field",
                  {
                    attrs: {
                      label: "Parcela inicial",
                      type: _vm.fields.firstPayment.type,
                      message: _vm.fields.firstPayment.message,
                    },
                  },
                  [
                    _c("b-numberinput", {
                      attrs: {
                        id: "input-first-payment",
                        placeholder: _vm.minPaymentNumber,
                        step: "1",
                        min: _vm.minPaymentNumber,
                        max: _vm.maxPaymentNumber,
                        "controls-position": "compact",
                        expanded: false,
                      },
                      on: { input: _vm.verifyFields },
                      model: {
                        value: _vm.fields.firstPayment.number,
                        callback: function ($$v) {
                          _vm.$set(_vm.fields.firstPayment, "number", $$v)
                        },
                        expression: "fields.firstPayment.number",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  {
                    attrs: {
                      label: "Parcela final",
                      type: _vm.fields.lastPayment.type,
                      message: _vm.fields.lastPayment.message,
                    },
                  },
                  [
                    _c("b-numberinput", {
                      attrs: {
                        id: "input-last-payment",
                        placeholder: _vm.maxPaymentNumber,
                        step: "1",
                        min: _vm.minPaymentNumber,
                        max: _vm.maxPaymentNumber,
                        "controls-position": "compact",
                        expanded: false,
                      },
                      on: { input: _vm.verifyFields },
                      model: {
                        value: _vm.fields.lastPayment.number,
                        callback: function ($$v) {
                          _vm.$set(_vm.fields.lastPayment, "number", $$v)
                        },
                        expression: "fields.lastPayment.number",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  {
                    attrs: {
                      label: "CAP (%)",
                      type: _vm.fields.newInflationaryUpperBound.type,
                      message: _vm.fields.newInflationaryUpperBound.message,
                    },
                  },
                  [
                    _c("b-numberinput", {
                      attrs: {
                        id: "input-upper-bound",
                        placeholder:
                          _vm.fields.newInflationaryUpperBound.number,
                        step: "0.1",
                        min: "0",
                        "min-step": "0.01",
                        "icon-right": "percentage",
                        "controls-position": "compact",
                        expanded: false,
                      },
                      on: { input: _vm.verifyFields },
                      model: {
                        value: _vm.fields.newInflationaryUpperBound.number,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.fields.newInflationaryUpperBound,
                            "number",
                            $$v
                          )
                        },
                        expression: "fields.newInflationaryUpperBound.number",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "buttons" }, [
              _c(
                "button",
                {
                  staticClass: "button is-button-primary is-rounded",
                  attrs: { id: "apply-button", disabled: _vm.buttonIsDisabled },
                  on: {
                    click: function ($event) {
                      return _vm.showConfirmModal()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("applyButton")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "button is-button-primary-light is-rounded",
                  attrs: { id: "cancel-button" },
                  on: { click: _vm.cancelChanges },
                },
                [_vm._v(" " + _vm._s(_vm.$t("cancelButton")) + " ")]
              ),
            ]),
          ])
        : _c("div", [
            _vm.changesResult.error
              ? _c(
                  "div",
                  [
                    _vm.changesResult.message !== ""
                      ? _c("Message", {
                          attrs: {
                            message: _vm.changesResult.message,
                            icon: _vm.changesResult.icon,
                            "as-card": false,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c("h5", [_vm._v("Resultados")]),
                    _vm._m(0),
                    _vm._l(_vm.changesResult.result, function (payment) {
                      return _c(
                        "div",
                        {
                          key: payment.paymentNumber,
                          staticClass: "changes-details",
                        },
                        [
                          _c("p", [_vm._v(_vm._s(payment.paymentNumber))]),
                          payment.previousInflationaryUpperBound !==
                          payment.newInflationaryUpperBound
                            ? _c(
                                "b-tooltip",
                                {
                                  attrs: {
                                    label: `CAP antes de la modificación: ${(
                                      payment.previousInflationaryUpperBound *
                                      100
                                    ).toFixed(2)}%`,
                                    type: "is-light",
                                    position: "is-top",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "had-changed",
                                      attrs: {
                                        id: `payment-${payment.paymentNumber}-newUpperBound`,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            (
                                              payment.newInflationaryUpperBound *
                                              100
                                            ).toFixed(2)
                                          ) +
                                          "% "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _c(
                                "b-tooltip",
                                {
                                  attrs: {
                                    label: "CAP no fue modificado",
                                    type: "is-light",
                                    position: "is-top",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "had-not-changed",
                                      attrs: {
                                        id: `payment-${payment.paymentNumber}-newUpperBound`,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            (
                                              payment.newInflationaryUpperBound *
                                              100
                                            ).toFixed(2)
                                          ) +
                                          "% "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                          _c(
                            "div",
                            [
                              payment.newBoletoCreated
                                ? _c(
                                    "b-tooltip",
                                    {
                                      attrs: {
                                        label: "Se generó un nuevo boleto",
                                        type: "is-light",
                                        position: "is-top",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-solid fa-file-text had-changed",
                                      }),
                                    ]
                                  )
                                : payment.isPaid
                                ? _c(
                                    "b-tooltip",
                                    {
                                      attrs: {
                                        label:
                                          "No se cambió la tasa ni se creó un nuevo boleto porque la cuota ya se encuentra pagada",
                                        type: "is-light",
                                        position: "is-top",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-solid fa-file had-not-changed",
                                      }),
                                    ]
                                  )
                                : _c(
                                    "b-tooltip",
                                    {
                                      attrs: {
                                        label:
                                          payment.previousInflationaryUpperBound !==
                                          payment.newInflationaryUpperBound
                                            ? "Se cambió la tasa pero no se generó boleto porque la cuota aún no está disponible"
                                            : "No se requirió realizar cambios",
                                        type: "is-light",
                                        position: "is-top",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-solid fa-file had-not-changed",
                                      }),
                                    ]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
            _c(
              "button",
              {
                staticClass: "button is-button-primary is-rounded apply",
                attrs: { id: "thanks-button" },
                on: { click: _vm.finishChanges },
              },
              [_vm._v(" " + _vm._s(_vm.$t("thanksButton")) + " ")]
            ),
          ]),
      _c("OperationModifierConfirmModal", {
        attrs: {
          "first-payment": _vm.fields.firstPayment.number,
          "last-payment": _vm.fields.lastPayment.number,
          "new-inflationary-upper-bound":
            _vm.fields.newInflationaryUpperBound.number,
          "is-component-modal-active": _vm.isComponentModalActive,
        },
        on: {
          applyInflationaryUpperBoundChanges:
            _vm.applyInflationaryUpperBoundChanges,
          cancelModal: _vm.cancelModal,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "changes-details-header" }, [
      _c("p", [_vm._v("N")]),
      _c("p", [_vm._v("CAP")]),
      _c("p", [_vm._v("BOLETO")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }